import { apiRequest } from './api'

export function listCaseClasses() {
  return apiRequest('/settings/caseclass/list', {
    method: 'POST',
  })
}

export function addCaseClass(className) {
  return apiRequest('/settings/caseclass/add', {
    method: 'POST',
    body: JSON.stringify({ className }),
  })
}

export function removeCaseClass(caseClassId) {
  return apiRequest('/settings/caseclass/remove', {
    method: 'POST',
    body: JSON.stringify({ caseClassId }),
  })
}

export function listCaseTypes() {
  return apiRequest('/settings/casetype/list', {
    method: 'POST',
  })
}

export function addCaseType(caseType) {
  return apiRequest('/settings/casetype/add', {
    method: 'POST',
    body: JSON.stringify({ caseType }),
  })
}

export function removeCaseType(caseTypeId) {
  return apiRequest('/settings/casetype/remove', {
    method: 'POST',
    body: JSON.stringify({ caseTypeId }),
  })
}

export function listEventTypes() {
  return apiRequest('/settings/eventtype/list', {
    method: 'POST',
  })
}

export function addEventType(typeName) {
  return apiRequest('/settings/eventtype/add', {
    method: 'POST',
    body: JSON.stringify({ typeName }),
  })
}

export function removeEventType(eventTypeId) {
  return apiRequest('/settings/eventtype/remove', {
    method: 'POST',
    body: JSON.stringify({ eventTypeId }),
  })
}
